// Resolve a possibly-relative asset URL into a full URL using the backend host.
// Accepts: absolute http(s) URLs (returned as-is), or relative paths like
// "/api/uploads/logos/xxx.png" (prepended with REACT_APP_BACKEND_URL).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function resolveAssetUrl(u) {
  if (!u) return null;
  if (/^https?:\/\//i.test(u)) return u;
  if (u.startsWith("/")) return `${BACKEND_URL}${u}`;
  return `${BACKEND_URL}/${u}`;
}
